export default __webpack_public_path__ + "static/media/new.149a86d7.svg";